import { render, staticRenderFns } from "./Template9-1.vue?vue&type=template&id=249bf988&scoped=true&"
import script from "./Template9-1.vue?vue&type=script&lang=js&"
export * from "./Template9-1.vue?vue&type=script&lang=js&"
import style0 from "./Template9-1.vue?vue&type=style&index=0&id=249bf988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249bf988",
  null
  
)

export default component.exports